import tempMeeApi from '../../../apis/tempMee';
import { CAMPAIGNS_ENDPOINT } from './GetCampaigns';

/**
 * One discount campaign's uptake: `GET /v1/admin/campaigns/:id/report`
 * (campaign-service PR #79, GOTU-6598). Returns `{ redemptions, offices,
 * totalDiscount, optIns, optInsUnused }`. A 404 means the id names no
 * *discount* campaign — an incentive campaign 404s here too.
 */
export const getCampaignReport = async (campaignId) => {
  const response = await tempMeeApi.get(`${CAMPAIGNS_ENDPOINT}/${campaignId}/report`);

  return response.data;
};
